module.exports = __webpack_public_path__ + "static/media/18.ca20879e.jpeg";